import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacidadPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-4xl mx-auto px-4 py-16">
        {/* Botón volver arriba */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#E91E8C] hover:underline mb-8"
          onClick={() => window.scrollTo(0, 0)}
        >
          <ArrowLeft size={18} />
          Volver al inicio
        </Link>
        
        <h1 className="text-4xl font-bold mb-8">Política de Privacidad</h1>
        <p className="text-gray-400 mb-8">Última actualización: Septiembre 2026</p>
        
        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">1. Información que Recopilamos</h2>
            <p>En Darkar Company Studios, respetamos tu privacidad. La información que podemos recopilar incluye:</p>
            <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
              <li><strong>Datos de uso:</strong> Información sobre cómo interactúas con nuestro sitio (páginas visitadas, tiempo de permanencia)</li>
              <li><strong>Datos técnicos:</strong> Dirección IP, tipo de navegador, dispositivo utilizado</li>
              <li><strong>Cookies:</strong> Utilizamos cookies para mejorar la experiencia del usuario</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">2. Uso de la Información</h2>
            <p>Utilizamos la información recopilada para:</p>
            <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
              <li>Mejorar y optimizar nuestro sitio web</li>
              <li>Analizar patrones de uso y preferencias</li>
              <li>Proporcionar contenido relevante</li>
              <li>Cumplir con obligaciones legales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">3. Servicios de Terceros</h2>
            <p>Nuestro sitio utiliza servicios de terceros que pueden recopilar información:</p>
            <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
              <li><strong>YouTube:</strong> Para reproducción de videos (sujeto a la política de privacidad de Google)</li>
              <li><strong>Vimeo:</strong> Para reproducción de videos premium</li>
              <li><strong>Google Analytics:</strong> Para análisis de tráfico</li>
              <li><strong>Shopify:</strong> Para la tienda en línea</li>
              <li><strong>Redes sociales:</strong> Facebook, TikTok, Instagram (para métricas y contenido embebido)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">4. Cookies</h2>
            <p>Utilizamos cookies para:</p>
            <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
              <li>Recordar tus preferencias</li>
              <li>Analizar el tráfico del sitio</li>
              <li>Permitir funcionalidades de reproductores de video</li>
            </ul>
            <p className="mt-4">Puedes configurar tu navegador para rechazar cookies, aunque esto puede afectar la funcionalidad del sitio.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">5. Compartir Información</h2>
            <p>No vendemos ni compartimos tu información personal con terceros, excepto:</p>
            <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
              <li>Cuando sea requerido por ley</li>
              <li>Para proteger nuestros derechos legales</li>
              <li>Con proveedores de servicios que nos ayudan a operar el sitio (bajo acuerdos de confidencialidad)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">6. Seguridad</h2>
            <p>Implementamos medidas de seguridad para proteger la información, aunque ningún sistema es 100% seguro. Utilizamos conexiones cifradas (HTTPS) y prácticas de seguridad estándar de la industria.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">7. Tus Derechos</h2>
            <p>Dependiendo de tu ubicación, puedes tener derecho a:</p>
            <ul className="list-disc list-inside mt-2 space-y-2 ml-4">
              <li>Acceder a tus datos personales</li>
              <li>Solicitar la corrección de datos inexactos</li>
              <li>Solicitar la eliminación de tus datos</li>
              <li>Oponerte al procesamiento de tus datos</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">8. Menores de Edad</h2>
            <p>Nuestro contenido puede no ser apropiado para menores de 13 años. No recopilamos intencionalmente información de menores de edad sin el consentimiento de sus padres o tutores.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">9. Cambios a esta Política</h2>
            <p>Podemos actualizar esta política de privacidad ocasionalmente. Te notificaremos sobre cambios significativos publicando la nueva política en esta página.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">10. Contacto</h2>
            <p>Si tienes preguntas sobre esta política de privacidad, puedes contactarnos a través de nuestras redes sociales oficiales.</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#E91E8C] hover:underline"
            onClick={() => window.scrollTo(0, 0)}
          >
            <ArrowLeft size={18} />
            Volver al inicio
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
